module.exports = __webpack_public_path__ + "static/media/clay.55647028.png";